import { type FC } from 'react';
import { Shirt } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import type { SpecialEvent } from '@/types';

interface DressCodeSectionProps {
  event: SpecialEvent;
}

/**
 * Dress code section
 * Prominently displays dress code requirements with styled card
 */
export const DressCodeSection: FC<DressCodeSectionProps> = ({ event }) => {
  if (!event.dressCode) {
    return null;
  }

  return (
    <section className="py-16 bg-gradient-to-b from-turquoise-800 to-turquoise-900 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/3 w-72 h-72 bg-orange-500 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto">
          <Card className="bg-turquoise-900/60 backdrop-blur-sm border-2 border-orange-500/50 shadow-2xl shadow-orange-500/10">
            <CardHeader className="text-center pb-4">
              <div className="flex justify-center mb-4">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-xl shadow-orange-500/30 ring-4 ring-turquoise-800">
                  <Shirt className="h-10 w-10 text-white" />
                </div>
              </div>
              <CardTitle className="text-3xl font-viking text-white drop-shadow-lg">
                Dress Code
              </CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-4">
              <div className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg px-8 py-4 shadow-lg">
                <p className="text-2xl font-bold text-white">{event.dressCode}</p>
              </div>

              {event.dressCodeDetails && (
                <div className="mt-6 pt-6 border-t border-turquoise-600/50">
                  <p className="text-base text-white/80 leading-relaxed">
                    {event.dressCodeDetails}
                  </p>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
